export const CDN_AGENT_USERNAME_MAX_LENGTH = 50;
export const CDN_AGENT_USERNAME_REGEX = /^[a-z][a-z0-9_]*$/;
export const CDN_SHOP_USERNAME_REGEX = /^[a-zA-Z0-9._-]{3,80}$/;

export function normalizeCdnAgentUsername(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9_]/g, '');
}

export function getCdnAgentUsernameError(value: string): string | null {
  const normalized = normalizeCdnAgentUsername(value).trim();
  if (!normalized) {
    return 'Username is required';
  }
  if (normalized.length > CDN_AGENT_USERNAME_MAX_LENGTH) {
    return `Username must be at most ${CDN_AGENT_USERNAME_MAX_LENGTH} characters`;
  }
  if (!CDN_AGENT_USERNAME_REGEX.test(normalized)) {
    return 'Username must start with a letter and contain only lowercase letters, numbers, and "_"';
  }
  return null;
}

export function getCdnShopUsernameError(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  if (!CDN_SHOP_USERNAME_REGEX.test(trimmed)) {
    return '3–80 chars: letters, numbers, dot, underscore, dash';
  }
  return null;
}
